import {Injectable, OnDestroy} from '@angular/core';
import {MedicalRecordPainModel} from '../../api/model/medicalRecordPain.model';
import {AbstractFindAllService} from '../../../../../core/service/v2/service/findAll/abstractFindAll.service';
import {MedicalPainRepository} from './ngxr/medicalPain.repository';
import {MedicalPainDataServiceAdapter} from './ngxr/medicalPainDataService.adapter';

@Injectable()
export class MedicalPainFindAllService extends
    AbstractFindAllService<MedicalRecordPainModel, MedicalRecordPainModel>
    implements OnDestroy{

    constructor(private service: MedicalPainRepository,
                dataService: MedicalPainDataServiceAdapter) {
        super(service, dataService);
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }
}
